// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Voice_Wrapper__6Oz6D","Hero":"Voice_Hero__V5ulQ","Title":"Voice_Title__h3ZOa","Subtitle":"Voice_Subtitle__10Gz4","Slider":"Voice_Slider__1li3J"};